import React            from 'react';
import searchBarModel        from './SearchBarModel';
import { makeStyles, Theme } from '../utility/styles';
import { Observe }           from 'rewire-core';

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'stretch',
    padding: '3px',
    border: `1px solid ${theme.palette.neutralLight.main}`,
    borderRadius: '4px',
    background: theme.palette.common.white,
  },
});

const useStyles = makeStyles(styles);
export default function SearchBar() {
  const cls       = useStyles();
  return (
    <Observe>{() => (
      searchBarModel.SearchComponent ?   <div className={cls.root}><searchBarModel.SearchComponent /></div> : null
    )}</Observe>
  );
}
